import React, { Component } from 'react';
import { connect } from 'react-redux';
import DikeProxy from '@/Proxies/DikeProxy';

export default function(ContainedComponent, rootCategory) {
  const mapStateToProps = state => {
    const {
      restricted: {
        _session: { currentOwnerGuid },
      },
    } = state;

    if (!currentOwnerGuid) {
      return {
        appList: [],
      };
    }

    const {
      dike: { [currentOwnerGuid]: { appList = [] } = {} },
    } = state.restricted;
    return {
      appList: appList.filter(app =>
        Object.prototype.hasOwnProperty.call(app, rootCategory)
      ),
      currentOwnerGuid,
    };
  };

  class AppListSubHOC extends Component {
    componentDidMount() {
      const { currentOwnerGuid } = this.props;
      this.dikeProxySubscription = DikeProxy.subscribe(currentOwnerGuid);
    }

    componentDidUpdate() {
      const { currentOwnerGuid } = this.props;
      this.dikeProxySubscription.update(currentOwnerGuid);
    }

    componentWillUnmount() {
      this.dikeProxySubscription.unsubscribe();
      this.dikeProxySubscription = null;
    }

    render() {
      return <ContainedComponent {...this.props} />;
    }
  }

  return connect(
    mapStateToProps,
    null
  )(AppListSubHOC);
}



// WEBPACK FOOTER //
// ./src/subscribeHOCs/appList.js